import { Descriptions, Tag } from 'antd';
import { bankValueTypeLabels } from 'apps/investcore/constants/bank';
import { activeColors, activeLabels } from 'utils/constants';
import { formatDateTime } from 'utils/formatDate';
import { cloudflareCdn } from 'utils/image';

const TABLE_HEAD = ['', 'Code', 'ID'];

const ItemDetail = ({ item }) => {
  const status = item.status === 1001 ? 'active' : 'inactive';
  return (
    <div className="flex md:flex-row flex-col gap-4">
      <Descriptions column={1} bordered>
        <Descriptions.Item label="Name">{item.name}</Descriptions.Item>
        <Descriptions.Item label="Name (English)">
          {item.en_name}
        </Descriptions.Item>
        <Descriptions.Item label="Logo">
          {item.logo ? (
            <img width={100} src={cloudflareCdn(item.logo, 100)} />
          ) : (
            '-'
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Trading Name">
          {item.trading_name}
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          <Tag color={activeColors[status]}>
            {activeLabels[status] || status}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Updated">
          {formatDateTime(item.updated_at)}
        </Descriptions.Item>
        <Descriptions.Item label="Code">{item.code}</Descriptions.Item>

        <Descriptions.Item label="NHSV Code">
          {item.nhsv_code}
        </Descriptions.Item>
        <Descriptions.Item label="VCAM Code">
          {item.vcam_code}
        </Descriptions.Item>
        <Descriptions.Item label="ID">{item.id}</Descriptions.Item>
        <Descriptions.Item label="Fmarket ID">
          {item.fmarket_id}
        </Descriptions.Item>
        <Descriptions.Item label="VCAM ID">{item.vcam_id}</Descriptions.Item>
        <Descriptions.Item label="Account Nunber Format">
          {bankValueTypeLabels[item.account_number_format] ||
            item.account_number_format}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default ItemDetail;
